// src/components/IntroOverlay.jsx
import React from "react";
import "./intro.css";
// Nota: 'logo' depende de tu estructura de carpetas (por defecto es 'logo.svg')
import logo from "../assets/logo.svg";
import MARCA from "../config/marca";
import LogoTrsAnimado from "./LogoTrsAnimado";

// Saludo según la hora: la pantalla sale una vez al día, así que el primer saludo del día cambia con la jornada.
const saludo = () => {
  const h = new Date().getHours();
  if (h < 12) return "Buenos días";
  if (h < 19) return "Buenas tardes";
  return "Buenas noches";
};

export default function IntroOverlay({ visible }) {
  // TRS (sin marca configurada) usa su logo vectorial animado; las demás marcas usan su ícono con saludo y barra de progreso.
  const esTrs = !MARCA.id;

  return (
    // La clase intro--hide maneja el desvanecimiento (opacity: 0)
    <div className={`intro ${esTrs ? "intro--trs" : ""} ${visible ? "" : "intro--hide"}`} style={{ "--color-primary": MARCA.colorPrimario }}>
      {esTrs ? (
        <LogoTrsAnimado />
      ) : (
        <div className="intro__content">
          <div className="intro__logo-wrap">
            <span className="intro__halo" aria-hidden="true" />
            <img src={MARCA.icono || logo} alt="Logo de la Aplicación" className="intro__logo-img" />
          </div>

          <p className="intro__saludo">{saludo()}</p>

          <div className="intro__progress" role="progressbar" aria-label="Cargando">
            <span className="intro__progress-bar" />
          </div>
        </div>
      )}
    </div>
  );
}
